import { TextareaAutosize, TextareaAutosizeProps, styled } from '@mui/material';

export const CustomTextarea = styled(TextareaAutosize)<TextareaAutosizeProps>(({ theme }) => ({
  borderRadius: '8px',
  padding: '12px',
  border: '1px solid #B3B3B3',
  textAlign: 'left',
  '& textarea': {
    borderRadius: '8px',
    padding: '10px 14px',
    minHeight: '100px',
    width: '100%',
    resize: 'vertical',
  },
  '&::placeholder': {
    fontFamily: 'Be VietNam Pro',
    color: 'var(--Gray-400, #98A2B3)',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
  },
  '&:not(:placeholder-shown)': {
    fontFamily: 'Be VietNam Pro',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
  },
  '& .MuiFormHelperText-root': {
    marginLeft: 0,
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      border: '2px solid #B3B3B3',
    },
  },
}));
